__turbopack_context__.v({
  "cookiesButton": "styles-module__Gev0Vq__cookiesButton",
  "navLink": "styles-module__Gev0Vq__navLink",
  "navListItem": "styles-module__Gev0Vq__navListItem",
  "navSecondaryList": "styles-module__Gev0Vq__navSecondaryList",
  "navTitle": "styles-module__Gev0Vq__navTitle",
});
